import { useMemo, useRef, type RefObject } from 'react';

import { canvasContainer } from './SankeyCanvas.sty.js';
import { Canvas } from '../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../core/components/canvas/CanvasContext.js';
import type { CanvasShape } from '../../core/components/canvas/types/canvas-shape.js';
import { useDrawSankey } from '../hooks/use-draw-sankey.js';
import type { SankeyLayoutModel } from '../types/sankey-internal.js';

interface SankeyDrawProps {
  layout: SankeyLayoutModel;
  nodeColors: Map<string, string>;
}

function SankeyDraw({ layout, nodeColors }: Readonly<SankeyDrawProps>) {
  useDrawSankey(layout, nodeColors);
  return null;
}

SankeyDraw['displayName'] = 'SankeyDraw';

interface SankeyCanvasProps {
  nodeColors: Map<string, string>;
  layout: SankeyLayoutModel;
  width: number;
  height: number;
}

export function SankeyCanvas({
  nodeColors,
  layout,
  width,
  height,
}: Readonly<SankeyCanvasProps>) {
  const shapeRefs = useRef(new Map<string, RefObject<CanvasShape>>());
  const canvasContextValue = useMemo(
    () => ({ shapeRefs: shapeRefs.current }),
    [],
  );

  return (
    <div className={canvasContainer}>
      <CanvasContext.Provider value={canvasContextValue}>
        <Canvas width={width} height={height}>
          <SankeyDraw layout={layout} nodeColors={nodeColors} />
        </Canvas>
      </CanvasContext.Provider>
    </div>
  );
}

SankeyCanvas['displayName'] = 'SankeyCanvas';
